import styled from 'styled-components';

const TabLine = styled.div`
	position: absolute;
	bottom: 0;
	left: var(--left);
	width: var(--width);
	height: 2px;
	background-color: white;
	transition:
		left 0.25s ease,
		width 0.25s ease;
`;

export { TabLine };
